/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ResourceEntryType = {
  Function: "function",
} as const;
export type ResourceEntryType = OpenEnum<typeof ResourceEntryType>;

export type ResourceEntry = {
  /**
   * The ID of the resource
   */
  id: string;
  /**
   * The name of the resource
   */
  name: string;
  /**
   * The URN of the resource
   */
  resourceUrn: string;
  type: ResourceEntryType;
  /**
   * The uri of the resource
   */
  uri: string;
};

/** @internal */
export const ResourceEntryType$inboundSchema: z.ZodMiniType<
  ResourceEntryType,
  unknown
> = openEnums.inboundSchema(ResourceEntryType);

/** @internal */
export const ResourceEntry$inboundSchema: z.ZodMiniType<
  ResourceEntry,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    name: z.string(),
    resource_urn: z.string(),
    type: ResourceEntryType$inboundSchema,
    uri: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "resource_urn": "resourceUrn",
    });
  }),
);

export function resourceEntryFromJSON(
  jsonString: string,
): SafeParseResult<ResourceEntry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResourceEntry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResourceEntry' from JSON`,
  );
}
